export default __webpack_public_path__ + "static/media/StipendIcon.6312dab9.svg";